<ng-container [formGroup]="formData">
  <div class="input-group">
    <select class="form-control" [class.invalid-state-border]="invalid" formControlName="duration"
      (blur)="onTouched()">
      <option [ngValue]="0" disabled>Please choose...</option>
      @for (option of options$ | async; track option) {
        <option [ngValue]="option.seconds">{{ option.text }}</option>
      }
    </select>
    <span class="input-group-btn">
      <button class="btn btn-default" type="button" [disabled]="fcDuration.disabled"
      (click)="addCustomInterval()">Custom...</button>
    </span>
  </div>
</ng-container>

<ng-template #customDialog let-save="close" let-cancel="dismiss">
  <ng-container [formGroup]="dialogData">
    <div class="modal-header">
      <button type="button" class="close" (click)="cancel()"><i>&times;</i></button>
      <h4 class="modal-title">Custom polling interval</h4>
    </div>

    <div class="modal-body">

      <div class="form-group">
        <!-- <label for="itineraryName">Interval:</label> -->
        <div class="input-group">
          <input type="number" min="30" class="form-control text-right" formControlName="customInterval" />
          <span class="input-group-addon">seconds</span>
        </div>
        <div class="error"
          [class.invisible]="!fcCustomInterval.invalid || (!fcCustomInterval.dirty && !fcCustomInterval.touched)">
          @if (fcCustomInterval.errors?.required) {
            <div>Frequency is required</div>
          }
          @if (fcCustomInterval.errors?.min) {
            <div>Minimum value is 30 seconds</div>
          }
          @if (!fcCustomInterval.errors?.required && !fcCustomInterval.errors?.min) {
            <div>Error</div>
          }
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-primary" [disabled]="dialogData.invalid" (click)="save()">Save</button>
      <button type="button" class="btn btn-link" (click)="cancel()">Cancel</button>
    </div>
  </ng-container>
</ng-template>
